import React from "react";
import { useTranslation } from "../../i18n";

class ErrorBoundaryClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[ErrorBoundary]", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div className="flex flex-col items-center justify-center min-h-[300px] gap-4 p-8">
          <span className="material-symbols-outlined text-5xl text-error">error</span>
          <h2 className="text-lg font-bold text-on-surface">{this.props.titleText}</h2>
          <p className="text-sm text-on-surface-variant text-center max-w-md">
            {this.props.descriptionText}
          </p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 rounded-lg bg-primary text-on-primary text-sm font-medium hover:bg-primary/90 transition-colors"
          >
            {this.props.reloadText}
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

// Functional shell injects translations so the class can stay (class is required
// for componentDidCatch — error boundaries can't be hooks).
export default function ErrorBoundary({ children, fallback }) {
  const { t } = useTranslation();
  return (
    <ErrorBoundaryClass
      fallback={fallback}
      titleText={t("layout.errorBoundary.title")}
      descriptionText={t("layout.errorBoundary.description")}
      reloadText={t("layout.errorBoundary.reload")}
    >
      {children}
    </ErrorBoundaryClass>
  );
}
